"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _TrackingWrapper = _interopRequireDefault(require("../TrackingWrapper"));

var _excluded = ["dataQa", "disabled", "children", "onClick"];

/**
 * Round button with an icon inside.
 */
var IconButton = function IconButton(_ref) {
  var dataQa = _ref.dataQa,
      disabled = _ref.disabled,
      children = _ref.children,
      onClick = _ref.onClick,
      other = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_core.IconButton, (0, _extends2["default"])({
    "data-qa": dataQa,
    disabled: disabled,
    onClick: onClick
  }, other), children);
};

IconButton.propTypes = {
  /** Selector for QA */
  dataQa: _propTypes["default"].string.isRequired,

  /** If `true`, the primary button will be disabled. */
  disabled: _propTypes["default"].bool,

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired,

  /**
   * Callback fired when the component is clicked.
   *
   * **Signature:**
   * ```
   * function(event: object) => void
   * ```
   * *event*: The event source of the callback.
   */
  onClick: _propTypes["default"].func.isRequired
};
IconButton.defaultProps = {
  disabled: false
};

var _default = (0, _TrackingWrapper["default"])(IconButton, 'Icon button click');

exports["default"] = _default;